const e = -1, i = "chat-viewer-prefix-id", t = "chat-viewer-suffix-id";
export {
  e as IDX_NOT_FOUND,
  i as PREFIX_ID,
  t as SUFFIX_ID
};
